function About() {
  return (
    <>
      <div id="about">
        <div>
          코난 카드를 한국어로 변역한 페이지입니다. 번역 내용과 관련한 피드백은
          환영입니다.&nbsp;
          <a
            target="_blank"
            href="https://crystal-quince-dc4.notion.site/Conan-TCG-DECK-fb1ca0b8f57f43a5ad679c861b05decd?pvs=4"
          >
            수정 요청 페이지(link)
          </a>
          에 댓글✏️을 달아주세요.
        </div>
      </div>
    </>
  );
}

export default About;
